<template>
  <div class="promote">
    <section class="promote__banner">
      <h1>优质专业课程，帮助法律人业务提升</h1>
      <p>已有<span>15w+</span>位律师受益，内容浏览总次数超<span>{{ bannerData.pageView | wan }}</span>次</p>
      <!-- <p>已有<span>{{ bannerData.userView | wan }}</span>位律师受益，内容浏览总次数超<span>{{ bannerData.pageView | wan }}</span>次</p> -->
    </section>
    <section class="promote__filter">
      <span>专业领域：</span>
      <ul class="filter__list">
        <li v-for="filter in filters" :key="filter.type" @click="selectFilters(filter)" class="filter__item" :class="{'filter__item--active': filter.type === curFilterId}" :analysis-name="'线上课程_业务提升_标签_' + filter.name">
          {{ filter.name }}
        </li>
      </ul>
    </section>
    <section class="promote__order">
      <span v-for="order in orders" :key="order.id" @click="selectOrder(order)" :class="{'active': order.id === curOrderId}" :analysis-name="'线上课程_业务提升_' + order.name">
        {{ order.name }}
      </span>
    </section>
    <section class="promote__cards-wrapper">
      <ul v-if="promoteList.length !== 0" class="promote__cards">
        <li v-for="promote in promoteList" :key="promote.id" class="promote__card">
          <PromoteCard :card="promote" :is-login="isLogin" />
        </li>
      </ul>
      <div v-else class="no-course-tip">
        <vui-ico class="ico ibang-schedule" :w="128"></vui-ico>
        <p class="title">精彩内容，敬请期待</p>
      </div>
    </section>
    <Page :current="pageInfo.page" :total="pageInfo.total" :page-size="pageInfo.pageSize" @on-change="changePageHanlder" />
    <Loading v-show="loading" tips="加载中..." />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PromoteCard from '../components/PromoteCard.vue'
import Loading from '@/components/ui/Loading.vue'
import api from '@/api/home.js'
export default {
  name: 'promote',
  components: {
    PromoteCard,
    Loading,
  },
  computed: {
    ...mapState('app', ['isLogin']),
  },
  data () {
    return {
      bannerData: {
        pageView: 0,
        userView: 0,
      },
      filters: [],
      promoteList: [],
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 16,
      },
      curFilterId: '',
      orders: [
        {
          name: '最新',
          id: 1,
        },
        {
          name: '最热',
          id: 2,
        },
        {
          name: '推荐',
          id: 3,
        },
      ],
      curOrderId: 1,
      loading: false,
    }
  },
  methods: {
    async getBannerData () {
      const data = await api.getPromoteBanner()
      this.bannerData = data
    },
    // 获取业务提升过滤标签
    async getPromoteFilters () {
      const data = await api.getPromoteFilters()
      this.filters = data.categoryList
      this.filters.unshift({
        name: '全部',
        type: '',
      })
      const defaultType = +this.$route.query.type
      if (defaultType) {
        this.curFilterId = this.filters.find(filter => filter.type === defaultType) ? defaultType : ''
      }
    },
    // 选择业务提升标签
    selectFilters (filter) {
      if (this.curFilterId === filter.type) return
      this.curFilterId = filter.type
      this.pageInfo.page = 1
      this.$router.replace(`/records?order=${this.curOrderId}&type=${this.curFilterId}`)
      this.getPromoteList()
    },
    // 选择排序
    selectOrder (order) {
      if (this.curOrderId === order.id) return
      this.curOrderId = order.id
      this.pageInfo.page = 1
      this.$router.replace(`/records?order=${this.curOrderId}&type=${this.curFilterId}`)
      this.getPromoteList()
    },
    changePageHanlder (page) {
      this.pageInfo.page = page
      this.getPromoteList()
    },
    // 获取业务提升列表
    async getPromoteList () {
      this.loading = true
      const data = await api.getPromoteList({
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        order: this.curOrderId,
        type: this.curFilterId,
      }).finally(() => {
        this.loading = false
      })
      this.promoteList = data.list
      this.pageInfo.total = data.total
      this.$nextTick(() => {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
  },
  created () {
    let query = this.$route.query
    if (query.order) {
      this.curOrderId = +query.order
    }
  },
  async mounted () {
    this.getBannerData()
    await this.getPromoteFilters()
    await this.getPromoteList()
  },
}
</script>
<style lang="scss" scoped>
.promote {
  width: 1200px;
  margin-inline: auto;
  padding-block: 24px 120px;
  &__banner {
    width: 100%;
    height: 250px;
    background-image: url("/img/index-banner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 64px 60px;
    box-sizing: border-box;
    margin-bottom: 32px;
    h1 {
      font-size: 34px;
      font-family: MiSans-Semibold, MiSans;
      font-weight: 600;
      color: #333333;
      line-height: 46px;
      margin: 0 0 24px;
    }
    p {
      font-size: 19px;
      font-family: MiSans-Regular, MiSans;
      font-weight: 400;
      color: #333333;
      line-height: 25px;
      span {
        margin-inline: 8px;
        font-weight: bold;
        font-family: MiSans Semibold, MiSans;
        color: #FA8919;
      }
    }
  }
  &__filter {
    display: flex;
    align-items: flex-start;
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px 20px 4px;
    margin-bottom: 32px;
    box-sizing: border-box;
    span {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      margin-right: 12px;
      flex-shrink: 0;
      margin-bottom: 16px;
    }
    .filter {
      &__list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      &__item {
        height: 28px;
        margin-right: 8px;
        padding-inline: 12px;
        border-radius: 4px;
        line-height: 28px;
        font-size: 14px;
        color: #333333;
        margin-bottom: 16px;
        cursor: pointer;
        user-select: none;
        &--active {
          color: #FC7D13;
          background: #FFF5EB;
          font-weight: 500;
        }
      }
    }
  }
  &__order {
    display: flex;
    margin-bottom: 24px;
    padding-inline: 8px;
    span {
      font-size: 14px;
      color: #666666;
      margin-right: 20px;
      cursor: pointer;
      user-select: none;
      &.active {
        color: #FC7D13;
        font-weight: 500;
      }
    }
  }
  &__cards-wrapper {
    position: relative;
    min-height: 300px;
  }
  &__cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  &__card {
    /deep/ .ivu-poptip, /deep/ .ivu-poptip-rel {
      display: block;
    }
  }
  .ivu-page {
    margin-top: 40px;
    text-align: center;
  }
}
</style>
